<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-service">
      <div class="dashed"></div>
      <el-form :model="form" ref="form" label-position="top">
        <el-row>
          <el-col :span="24" class="contract-a">
            <div class="contract-form">
              <el-form-item :label="$t('crm_contract_upload.he_tong_wen_jian')" prop="file" :rules="rules.file">
                <t-upload
                  type="file"
                  v-model="form.fileList"
                  :bizId="contractId"
                  bizType="crm.contract"
                  ref="crmContract"
                  :limit="5"
                  @effect="checkImg"
                  accept="application/pdf,application/msword"
                  :autoUpload="false"
                ></t-upload>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <!-- 框架协议 -->
      <template v-if="backType==='agreement'">
        <el-button @click="preStep">{{$t('crm_contract_upload.sybxzzlfahhcxx')}}</el-button>
      </template>
      <!-- 租赁合同 -->
      <template v-else-if="contractClass==='20'">
          <el-button @click="preStep">{{$t('crm_contract_upload.sybxzzlfa')}}</el-button>
      </template>
      <template v-else-if="contractClass==='40'">
        <el-button @click="preStep">{{$t('crm_contract_upload.sybsbxx')}}</el-button>
      </template>
      <!-- 租赁合同续租 -->
      <template v-else-if="backType==='continueRent'||(`${contractClass}`==='20'&&backType==='testToRent')">
          <el-button @click="preStep">{{$t('crm_contract_upload.sybhtxx')}}</el-button>
      </template>
      <template v-else-if="`${contractClass}`==='31'&&backType==='testToRent'">
          <el-button @click="preStep">{{$t('crm_contract_upload.sybtxljhc')}}</el-button>
      </template>
      <template v-else-if="`${contractClass}`==='31'&&backType==='continueOrder'">
          <el-button @click="preStep">{{$t('crm_contract_upload.sybhtxx')}}</el-button>
      </template>
      <template v-else>
          <el-button @click="preStep">{{$t('crm_contract_upload.sybtxljhc')}}</el-button>
      </template>
      <el-button type="primary" @click="saveContract(true)">{{$t('crm_contract_upload.bao_cun_ti_jiao')}}</el-button>
      <el-button type="primary" @click="saveContract(false)">{{$t('crm_contract_upload.bao_cun_cao_gao')}}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';


export default {
  components: { tUpload },
  props: {
    backType: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number],
  },
  watch: {},
  data() {
    return {
      // 服务中心
      form: {
        file: '',
        fileList: [],
      },

      // 公司ID
      // contractId: '',
      // 售后公司列表
      allServiceList: [],
    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

  },

  computed: {
    rules() {
      return {
        file: { required: true, message: this.$t('crm_contract_upload.qscxxqddht') }, // 上传签订合同
        fileList: [],
      };
    },
  },
  methods: {

    // 图片校验
    checkImg() {
      if (this.form.fileList && this.form.fileList.length > 0) {
        this.form.file = 'file';
      } else {
        this.form.file = '';
      }
    },
    // 保存签订合同
    saveContract: async function (isStartApprove) {
      this.$refs.form.validate(async (valid) => {
        await this.$refs.crmContract.submit();
        if (!valid) {
          return;
        }
        const parameter = {};
        parameter.operateFlag = this.operateFlag;
        parameter.bizId = this.contractId;
        parameter.bizClass = this.contractClass;
        parameter.isStartApprove = isStartApprove;
        // 只保存id
        parameter.attachList = this.form.fileList;

        // 保存交互
        this.$postJSON(apis.crmContractSaveAttach, parameter).then((res) => {
          // 有返回值代表成功
          if (res.code === 0) {
            this.$message({
              message: this.$t('Common.com_save_success'),
              type: 'success',
            });
            // this.jump('/contract/management', { refresh: true }, true);
            this.$emit('successJump');
          }
        });
        // this.saveAddCompany();

      });
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
      // this.jump('/contract/management', { refresh: true }, true);
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-service {
  padding: 14px 24px 0;
}
</style>
